import { useSearchParameters } from "@/components/signup/hooks/use-search-parameters";

import {
    KANBAN_TEAM_MANAGED_KEY,
    SCRUM_TEAM_MANAGED_KEY
} from "../models/percieved-provisioning";
import { getJtbdTemplateOverrideQueryParam } from "../utils/utils";

export const useRecommendedTemplate = () => {
    const { templateId, templateChoice } = useSearchParameters();

    const resolvedTemplateId = () => {
        const jtbdTemplateOverride = getJtbdTemplateOverrideQueryParam() ?? "";
        if (templateChoice === "kanban" || jtbdTemplateOverride === "kanban") {
            return KANBAN_TEAM_MANAGED_KEY;
        } else if (
            templateChoice === "scrum" ||
            jtbdTemplateOverride === "scrum"
        ) {
            return SCRUM_TEAM_MANAGED_KEY;
        }

        return jtbdTemplateOverride;
    };

    return templateId ?? resolvedTemplateId();
};
